import { RouteScreenContext } from 'components/app/AppContext';
import { ScreenTemplate } from './ScreenTemplate';
import { usePreload } from './usePreload';

import type { Route } from 'components/app/routes/app-routes-revamp';

type RouteScreenProps = {
  route: Route;
  routes: Route[];
};

export const RouteScreen = (props: RouteScreenProps) => {
  const { route, routes } = props;
  const { Template: RouteTemplate, noIndex } = route;
  const routeScreenContextValue = { route, routes };
  const Template = RouteTemplate || ScreenTemplate;

  usePreload(routes);

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <RouteScreenContext.Provider value={routeScreenContextValue}>
        <main id="#content">
          <Template {...route} />
        </main>
      </RouteScreenContext.Provider>
    </>
  );
};
